import React from "react";
import PropTypes from "prop-types";
import { PlayIcon, FavoritesIcon, PauseIcon } from "../components";
import { Link, useNavigate } from "react-router-dom";
// import { PauseIcon } from "lucide-react";

const PlayListItem = ({
  title,
  duration,
  mediaUrl,
  favorite,
  slug,
  onToggleFavorite,
  dayData,
  onPlay,
  isPlaying,
  isActive,
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/devotion/${slug}`, { state: { dayData } });
  };
  return (
    <div
      className="flex items-center justify-between px-4 py-2.5 cursor-pointer"
      onClick={handleCardClick}
    >
      <div className="flex items-center">
        <div className="w-6 h-6 flex items-center justify-center">
          {mediaUrl ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onPlay();
              }}
              aria-label="Play Media"
            >
              {isActive && isPlaying ? (
                <PauseIcon className="w-5 h-5 text-gold-500" />
              ) : (
                <PlayIcon className="w-5 h-5 text-black hover:text-gold-500" />
              )}
            </a>
          ) : null}
        </div>
        <div className="flex flex-col ml-4 flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 mb-0.5 leading-4.5">
            {title}
          </p>
          <span className="text-xs text-gray-600 leading-4">{duration}</span>
        </div>
      </div>
      <div>
        <button
          type="button"
          className="focus:outline-none group"
          aria-label={favorite ? "Remove from Favorites" : "Add to Favorites"}
          onClick={(e) => {
            e.stopPropagation();
            onToggleFavorite();
          }}
        >
          <FavoritesIcon
            filled={favorite}
            className={`h-6 w-6 group-hover:text-red-100 ${favorite ? "text-red-100" : "text-gray-500"}`}
          />
        </button>
      </div>
    </div>
  );
};

PlayListItem.propTypes = {
  title: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  mediaUrl: PropTypes.string.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  slug: PropTypes.string.isRequired,
};

export default PlayListItem;
